import { render, staticRenderFns } from "./Oportunidades.vue?vue&type=template&id=5e769608"
import script from "./Oportunidades.vue?vue&type=script&lang=js"
export * from "./Oportunidades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports